//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { contractCreateApi, contractEditCreateApi, contractAddApi, contractEditApi } from '@/api/enterprise';
export default {
  name: 'AddContract',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    oaForm: function oaForm() {
      return import('@/components/customer/oaForm');
    },
    editContract: function editContract() {
      return import('@/views/customer/contract/components/editContract');
    }
  },
  data: function data() {
    return {
      row: {},
      drawer: false,
      direction: 'rtl',
      fromInfo: [],
      addText: '',
      fromData: {},
      itemData: null
    };
  },
  watch: {},
  methods: {
    handleClose: function handleClose() {
      this.drawer = false;
    },
    // 获取新增表单
    getData: function getData() {
      var _this = this;
      contractCreateApi().then(function (res) {
        if (_this.formData && _this.formData.id) {
          res.data.forEach(function (item) {
            item.data.forEach(function (val) {
              if (val.key == 'contract_customer') {
                val.value = _this.formData.id;
              }
            });
          });
        }
        _this.fromInfo = res.data;
      });
    },
    // 获取编辑表单
    getEditData: function getEditData() {
      var _this2 = this;
      contractEditCreateApi(this.row.id).then(function (res) {
        _this2.fromInfo = res.data;
      });
    },
    openBox: function openBox(data) {
      if (data) {
        this.row = data;
        this.getEditData();
      } else {
        this.getData();
      }
      this.drawer = true;
    },
    // 提交成功
    submitOk: function submitOk(data, type) {
      var _this3 = this;
      if (this.row.id) {
        contractEditApi(this.row.id, data).then(function (res) {
          if (res.status == 200) {
            if (type == 1) {
              data.eid = data.contract_customer;
              data.cid = _this3.row.id;
              _this3.fromData = {
                title: '查看合同',
                width: '1000px',
                data: data,
                isClient: false,
                name: _this3.formData.name,
                id: _this3.row.id,
                edit: true
              };
              _this3.$nextTick();
              _this3.$refs.editContract.tabIndex = '2';
              _this3.$refs.editContract.tabNumber = 2;
              _this3.$refs.editContract.openBox(_this3.row);
            } else {
              _this3.drawer = false;
              _this3.$emit('getTableData');
              _this3.$refs.oaForm.resetForm();
            }
            _this3.$refs.oaForm.saveLoading = false;
            _this3.$refs.oaForm.addContractLoading = false;
          } else {
            _this3.$refs.oaForm.saveLoading = false;
            _this3.$refs.oaForm.addContractLoading = false;
          }
        }).catch(function (err) {
          _this3.$refs.oaForm.resetForm();
        });
      } else {
        contractAddApi(data).then(function (res) {
          if (res.status == 200) {
            if (type == 1) {
              _this3.drawer = false;
              data.eid = data.contract_customer;
              data.cid = res.data.id;
              _this3.fromData = {
                title: '查看合同',
                width: '1000px',
                data: data,
                isClient: false,
                name: _this3.formData.name,
                id: res.data.id,
                edit: true
              };
              _this3.$refs.editContract.tabIndex = '2';
              _this3.$refs.editContract.tabNumber = 2;
              _this3.$refs.editContract.openBox(_this3.fromData);
            } else {
              _this3.drawer = false;
              _this3.$refs.oaForm.resetForm();
              _this3.$emit('getTableData');
            }
            _this3.$refs.oaForm.saveLoading = false;
            _this3.$refs.oaForm.addContractLoading = false;
          } else {
            _this3.$refs.oaForm.saveLoading = false;
            _this3.$refs.oaForm.addContractLoading = false;
          }
        }).catch(function (err) {
          _this3.$message.error(err);
          // this.$refs.oaForm.resetForm()
        });
      }
    },
    addContinueOk: function addContinueOk(data) {
      this.submitOk(data, 1);
    },
    handlePayment: function handlePayment() {
      var _this4 = this;
      this.addText = 'on';
      this.$refs.contractInfo.handleConfirm().then(function () {
        setTimeout(function () {
          _this4.fromData = {
            title: _this4.$t('customer.viewcustomer'),
            width: '1000px',
            data: _this4.itemData,
            isClient: false,
            name: _this4.formData.name,
            id: _this4.itemData.id,
            edit: true
          };
          _this4.$refs.editContract.tabIndex = '2';
          _this4.$refs.editContract.tabNumber = 2;
          _this4.drawer = false;
          setTimeout(function () {
            _this4.$refs.editContract.openBox();
            _this4.addText = '';
            _this4.$refs.contractInfo.reset();
            _this4.$refs.contractInfo.contractList();
          }, 500);
        }, 300);
      });
    }
  }
};